import { useHover as useHoverWeb } from '@react-aria/interactions';
import { useEffect } from 'react';
import { attachEventHandlersOnRef } from '@react-native-aria/utils';
export var useHover = function useHover(props, ref) {
  var params = useHoverWeb(props);
  useEffect(function () {
    attachEventHandlersOnRef(params.hoverProps, ref);
  }, []);
  return params;
};